const bakery_button     = {
    bakery_button:

<svg
xmlns="http://www.w3.org/2000/svg"
width="512"
height="512"
enableBackground="new 0 0 512 512"
viewBox="0 0 512 512"
>
<g xmlns="http://www.w3.org/2000/svg">
  <path
    fill="#ff0909"
    d="M422.762 507.605l-87.518-87.503-42.422 42.422c-3.662 3.662-8.979 5.171-14.048 3.999a14.982 14.982 0 01-10.781-9.858l-84.858-254.561a14.995 14.995 0 013.618-15.352c3.999-3.999 9.961-5.464 15.352-3.618l254.561 84.858a14.982 14.982 0 019.858 10.781 15.015 15.015 0 01-3.999 14.048l-42.422 42.422 87.503 87.517c5.859 5.859 5.859 15.352 0 21.211l-63.633 63.633c-5.86 5.861-15.352 5.861-21.211.001zM195 120c-8.291 0-15-6.709-15-15V15c0-8.291 6.709-15 15-15s15 6.709 15 15v90c0 8.291-6.709 15-15 15zM120.762 141.973L57.114 78.325c-5.859-5.859-5.859-15.352 0-21.211s15.352-5.859 21.211 0l63.647 63.647c5.859 5.859 5.859 15.352 0 21.211-5.859 5.86-15.351 5.86-21.21.001zM57.114 332.886c-5.859-5.859-5.859-15.352 0-21.211l63.647-63.647c5.859-5.859 15.352-5.859 21.211 0s5.859 15.352 0 21.211l-63.647 63.647c-5.859 5.859-15.351 5.859-21.211 0zM248.027 141.973c-5.859-5.859-5.859-15.352 0-21.211l63.647-63.647c5.859-5.859 15.352-5.859 21.211 0s5.859 15.352 0 21.211l-63.647 63.647c-5.859 5.859-15.351 5.859-21.211 0zM105 210H15c-8.291 0-15-6.709-15-15s6.709-15 15-15h90c8.291 0 15 6.709 15 15s-6.709 15-15 15z"
    data-original="#000000"
  ></path>
</g>
</svg>

}

export default bakery_button;